import type { NestedColumn, NestedState } from '../securitee/NestedTable'

/**
 * Cautarea, sortarea si paginarea PE CLIENT, pentru cele trei liste din randul
 * desfasurat care vin intregi de la API si erau desenate in v4 ca tabele goale:
 * My Applications (`applications_list.php`), Productivity History
 * (`history.php`) si Blocked (`blocked_applications.php`).
 *
 * In portalul vechi toate trei erau `DataTable` fara `serverSide`, adica exact
 * asta: casuta de cautare, capete care sorteaza, meniul de lungime si paginile,
 * toate peste randurile deja aduse. Capetele fara paginare din v4 nu au de unde
 * sa le faca - deci se fac aici, nu se cer de la API.
 *
 * Nu e o listă server-side deghizata: cate randuri vin, atatea se cerne. Pentru
 * liste care chiar nu incap in pagina trebuie capat paginat, si aia e alta
 * munca, pe `v4/api`.
 */

export interface LocalColumn extends NestedColumn {
  /** Campul dupa care se sorteaza si se cauta, daca nu e chiar `key`. */
  sortKey?: string
  /** `searchable: false` din columnDefs (Start si End in history-1.js). */
  searchable?: boolean
}

function value(row: Record<string, unknown>, col: LocalColumn): unknown {
  return row[col.sortKey ?? col.key]
}

function compare(a: unknown, b: unknown): number {
  const na = Number(a)
  const nb = Number(b)
  if (a !== null && a !== '' && b !== null && b !== '' && Number.isFinite(na) && Number.isFinite(nb)) return na - nb
  return String(a ?? '').localeCompare(String(b ?? ''), undefined, { numeric: true, sensitivity: 'base' })
}

/** Randurile de pe pagina ceruta, si cate sunt dupa cautare. */
export function localPage(rows: Record<string, unknown>[], columns: LocalColumn[], state: NestedState): { rows: Record<string, unknown>[]; total: number } {
  const needle = state.search.trim().toLowerCase()
  let kept = rows
  if (needle !== '') {
    const searchable = columns.filter((c) => c.searchable !== false)
    kept = rows.filter((r) => searchable.some((c) => String(value(r, c) ?? '').toLowerCase().includes(needle)))
  }
  const col = columns[state.order.column]
  if (col && col.orderable !== false) {
    const dir = state.order.dir === 'asc' ? 1 : -1
    kept = [...kept].sort((a, b) => dir * compare(value(a, col), value(b, col)))
  }
  return { rows: kept.slice(state.start, state.start + state.length), total: kept.length }
}
